export default "__VITE_ASSET__CqGJBp$K__"